
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinsanaswadi() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Sanaswadi',
        heading: 'etravo : Corporate Cab and Bus Services in Sanaswadi',
        headingDescription: 'eTravo provides efficient and dependable Corporate Cab and Bus Services in Sanaswadi, catering to the transportation needs of industrial units and corporate establishments. Whether your business requires executive cabs for official travel or large-capacity buses for employee commutes and factory shifts, our fleet is equipped for reliable and timely service. With GPS-enabled vehicles, trained chauffeurs, and a strong focus on safety and professionalism, eTravo ensures smooth and scalable corporate mobility in and around Sanaswadi Industrial Area.',

        top: 'Top Places to Visit in Sanaswadi with etravo',
    "topPlaces": [
    {
      "title": "Ranjangaon Mahaganapati Temple",
      "description": "Located approximately 20 km from Sanaswadi, this revered temple is one of the Ashtavinayak shrines dedicated to Lord Ganesha. The temple's architecture and spiritual ambiance attract devotees and tourists alike."
    },
    {
      "title": "Chondhe Farms Resort",
      "description": "A popular getaway near Sanaswadi, Chondhe Farms offers a rustic experience with traditional Maharashtrian cuisine, outdoor activities, and serene surroundings, making it ideal for family outings and day trips."
    },
    {
      "title": "Sambhaji Maharaj Samadhi",
      "description": "Situated in the nearby village of Tulapur, this memorial honors Chhatrapati Sambhaji Maharaj, the son of Shivaji Maharaj. The site holds historical significance and is a place of reverence for many."
    },
    {
      "title": "Shri Wagheshwar Temple",
      "description": "Located in Wagholi, about 25 km from Sanaswadi, this ancient temple dedicated to Lord Shiva is known for its tranquil environment and traditional architecture, attracting devotees year-round."
    },
    {
      "title": "Devkund Waterfall Trek",
      "description": "Approximately 70 km from Sanaswadi, Devkund is a picturesque waterfall nestled in the Sahyadri hills. The trek to the waterfall is popular among adventure enthusiasts and nature lovers."
    },
    {
      "title": "Tamhini Ghat",
      "description": "Around 80 km from Sanaswadi, Tamhini Ghat is a mountain pass known for its scenic beauty, especially during the monsoon season. The area is dotted with waterfalls, lush greenery, and offers breathtaking views."
    },
    {
      "title": "Kundalika Valley",
      "description": "Located near Tamhini Ghat, Kundalika Valley is famous for white-water rafting and other adventure activities. The valley's natural beauty makes it a favored spot for thrill-seekers and campers."
    },
    {
      "title": "Lavasa Lake",
      "description": "Approximately 90 km from Sanaswadi, Lavasa is a planned city modeled on the Italian town of Portofino. The Lavasa Lakefront offers boating, dining, and picturesque views, making it a popular weekend destination."
    },
    {
      "title": "Raigad Fort",
      "description": "Situated about 100 km from Sanaswadi, Raigad Fort was the capital of Chhatrapati Shivaji Maharaj's kingdom. The fort stands as a symbol of Maratha pride and offers panoramic views of the surrounding region."
    },
    {
      "title": "Garudmaachi Training Camp",
      "description": "Located near Tamhini Ghat, Garudmaachi is an adventure and training camp offering activities like rappelling, rock climbing, and team-building exercises, set amidst serene natural surroundings."
    }
  ],
  "services": [
    {
      "name": "Business Transport Services in Sanaswadi",
      "description": "eTravo provides reliable business transport services in Sanaswadi, tailored for companies operating in the MIDC industrial area. We offer professional cab and bus services for daily employee movement, shift transport, and executive travel. Our well-maintained vehicles and experienced drivers ensure timely and safe transportation, improving overall staff efficiency and company operations."
    },
    {
      "name": "Corporate Shuttle Services for Factories in Sanaswadi",
      "description": "Our corporate shuttle services in Sanaswadi are designed to meet the needs of factories and manufacturing units requiring mass employee transit. eTravo provides shift-based shuttle buses that run on fixed routes, covering key residential clusters. With real-time tracking, professional drivers, and on-time schedules, we ensure your workforce arrives safely and punctually for every shift."
    },
    {
      "name": "Cab & Bus Hire for Employees in Sanaswadi",
      "description": "eTravo offers flexible cab and bus hire options for employee transportation in Sanaswadi. Choose from a variety of vehicle types including hatchbacks, sedans, tempo travellers, and buses to match your staffing size and transport requirements. Whether you need daily commutes, project-based logistics, or on-call transport, we provide scalable and cost-effective solutions."
    },
    {
      "name": "Sanaswadi MIDC Corporate Commute Solutions",
      "description": "eTravo delivers end-to-end corporate commute solutions for companies in Sanaswadi MIDC. We specialize in managing large-scale staff transport with fully managed cab and bus services. Our operations team ensures route optimization, vehicle tracking, and driver coordination for seamless movement of employees between their homes and your facility, reducing delays and increasing operational efficiency."
    },
    {
      "name": "Affordable Cab Services for Companies in Sanaswadi",
      "description": "Looking for budget-friendly transport options in Sanaswadi? eTravo provides affordable corporate cab services for daily commutes, site visits, and executive transport. We offer competitive pricing, transparent billing, and reliable service to support companies with small to mid-sized teams who need quality mobility solutions without overspending."
    },
    {
      "name": "Employee Bus Service in Sanaswadi",
      "description": "Our employee bus services in Sanaswadi are perfect for organizations needing regular, large-scale transport for their workforce. With options for 20 to 50-seater AC buses, eTravo ensures comfort, safety, and punctuality. We support shift-based scheduling, factory hours, and long-term rental contracts, helping companies reduce absenteeism and improve employee satisfaction."
    }
  ],
  "tableData": [
    ["Business Transport Services in Sanaswadi", "Corporate Shuttle Services for Factories in Sanaswadi"],
    ["Cab & Bus Hire for Employees in Sanaswadi", "Sanaswadi MIDC Corporate Commute Solutions"],
    ["Affordable Cab Services for Companies in Sanaswadi", "Employee Bus Service in Sanaswadi"]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Reliable Transportation for Sanaswadi’s Industrial Zone",
        "WhyChoosedescription": "Sanaswadi, being home to major manufacturing and logistics units, demands punctual and structured transport. eTravo provides dependable corporate cab and bus services for daily employee commutes, shift-based operations, and executive travel—ensuring seamless movement to and from Sanaswadi Industrial Area."
    },
    {
        "WhyChooseheading": "Fleet Tailored for Industrial & Corporate Needs",
        "WhyChoosedescription": "Our diverse fleet includes everything from executive sedans and SUVs for top management to high-capacity, air-conditioned buses for workforce shuttles. Each vehicle is spacious, well-maintained, and designed to support the daily operational needs of companies in and around Sanaswadi."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
        "WhyChoosedescription": "Our drivers are trained professionals who understand Sanaswadi’s traffic conditions, factory shift patterns, and routes to nearby areas like Ranjangaon, Wagholi, and Pune city. Their local expertise ensures safe, smooth, and timely transportation for your employees and guests."
    },
    {
        "WhyChooseheading": "Shift-Friendly and Flexible Transport Schedules",
        "WhyChoosedescription": "We specialize in shift-based transport. Whether your team works early mornings, late nights, or round-the-clock, eTravo provides transport solutions that align with your operational hours. Our systems are optimized to manage multiple shifts and rotating schedules efficiently."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Corporate Billing",
        "WhyChoosedescription": "eTravo offers competitive, contract-friendly pricing with no hidden charges. We provide GST-compliant invoices, monthly billing options, and custom transport packages tailored to your company’s size and budget—ideal for growing industries and MNCs operating in Sanaswadi."
    },
    {
        "WhyChooseheading": "Safety-Focused Travel Experience",
        "WhyChoosedescription": "All vehicles are equipped with GPS tracking, emergency kits, seat belts, fire extinguishers, and undergo regular maintenance. We follow stringent hygiene and safety protocols, ensuring your employees travel in a secure and clean environment—every time."
    },
    {
        "WhyChooseheading": "24/7 Support and Real-Time Ride Monitoring",
        "WhyChoosedescription": "Sanaswadi operates beyond regular hours, and so do we. Our transport coordination team is available 24/7 to manage schedules, track rides in real-time, and resolve any issues instantly. With eTravo, you're never left in the dark, no matter what time your operations run."
    },
    {
        "WhyChooseheading": "Custom Corporate Transport Plans for Sanaswadi Businesses",
        "WhyChoosedescription": "Whether you’re a factory, logistics hub, or corporate office, we create personalized travel solutions tailored to your needs. From daily employee shuttles and client transport to outstation logistics—we manage it all under one professional service umbrella."
    }
]





























    }

// Corporate Cab and Bus Services in Sanaswadi – eTravo

const faqData = [
    [
        {
            question: 'What types of corporate transport services does eTravo offer in Sanaswadi?',
            answer: 'eTravo provides professional cab and bus services in Sanaswadi for corporate and industrial clients, including employee transport, executive car rentals, shift-based travel, and factory visit coordination.',
        },
        {
            question: 'Can eTravo manage employee transportation for manufacturing units in Sanaswadi?',
            answer: 'Yes, we specialize in industrial zone logistics. Our transport solutions are optimized for multi-shift operations, ensuring timely staff movement with well-planned routes and GPS-enabled vehicles.',
        },
        {
            question: 'What vehicle types are available for corporate travel in Sanaswadi?',
            answer: 'Our fleet includes sedans, hatchbacks, SUVs, tempo travellers, and AC buses (13–50 seaters), all maintained to high standards and suitable for both daily commutes and on-demand travel.',
        },
        {
            question: 'Does eTravo provide safety and tracking features for its transport services?',
            answer: 'Absolutely. Every vehicle is GPS-tracked in real-time, with automated trip logs, driver background checks, and compliance with corporate safety protocols.',
        },
        {
            question: 'Can we book cabs or buses for client visits, audits, or intercity meetings?',
            answer: 'Yes, we offer on-demand and scheduled cab and bus services for audits, vendor meetings, site inspections, and corporate travel from Sanaswadi to nearby cities.',
        },
        {
            question: 'Is dedicated transport support available for corporate clients in Sanaswadi?',
            answer: 'Yes, each client is assigned a dedicated account manager to handle bookings, routing, reporting, and all support needs related to daily or event-based transportation.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Pradeep Naik',
        designation: 'Admin Head, MegaVolt Industries',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s bus and cab service in Sanaswadi is reliable and efficient. We’ve seen a major improvement in shift punctuality since partnering with them. Highly recommended for industrial zones.”',
    },
    {
        name: 'Ms. Varsha Kumbhar',
        designation: 'HR Executive, TechLine Systems',
        rating: [1, 1, 1, 1, 1],
        text: '“Our employee transport was scattered until we moved to eTravo. Their team helped us streamline everything for our Sanaswadi plant. The support and fleet quality are excellent.”',
    },
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Sanaswadi",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-sanaswadi.jpg",
  "description": "Reliable corporate cab and bus services in Sanaswadi by eTravo. Ideal for factory shuttle, employee transport, and corporate commute solutions in Sanaswadi MIDC. Affordable and comfortable AC vehicles available.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1950"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-sanaswadi"
  }
};




    return (
        <div>


<Helmet>
  <title>Corporate Cab and Bus Services in Sanaswadi | Employee Shuttle & Factory Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Sanaswadi with eTravo for factory shuttle, employee transport, and corporate commute solutions in Sanaswadi MIDC. Affordable AC vehicles and reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/16.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinsanaswadi;